/** Debug overlay drawing the active A* pathfinding route for each enemy. */
import Phaser from 'phaser';
import { Enemy } from '../../entities/Enemy';

const PATH_LINE_WIDTH = 1.5;
const PATH_LINE_ALPHA = 0.6;
const PATH_LINE_COLORS: Record<string, number> = {
  duty: 0x00cc00, alert: 0xcccc00, chase: 0xcc2222, search: 0xcccc00,
  using_skill: 0xcc2222, stagger: 0x8888cc,
};

/** Renders each enemy's current navigation path as a colored polyline. */
export class PathOverlay {
  /** Draw the remaining path segment for every enemy that has an active path. */
  draw(graphics: Phaser.GameObjects.Graphics, enemies: readonly Enemy[]): void {
    for (const enemy of enemies) {
      const ai = enemy.ai;
      const path = ai.currentPath;
      const pathIndex = ai.currentPathIndex;

      if (path.length === 0 || pathIndex >= path.length) continue;

      const color = PATH_LINE_COLORS[ai.state] ?? 0xcccccc;
      graphics.lineStyle(PATH_LINE_WIDTH, color, PATH_LINE_ALPHA);
      graphics.beginPath();
      graphics.moveTo(enemy.sprite.x, enemy.sprite.y);

      for (let i = pathIndex; i < path.length; i++) {
        graphics.lineTo(path[i].x, path[i].y);
      }
      graphics.strokePath();

      const last = path[path.length - 1];
      graphics.fillStyle(color, 0.8);
      graphics.fillCircle(last.x, last.y, 3);
    }
  }

  clear(): void { /* graphics-only */ }
  destroy(): void { /* nothing to clean up */ }
}
